import { useAppDispatch } from 'app/store';
import { setHeaderAction, setHeaderTitle } from 'features/ui/model/uiSlice';
import { FC, useEffect } from 'react';
import ShopDotsUploadDotsWidget from 'widgets/shopDots/ui/ShopDotsUploadDotsWidget';

const ShopDotsUpdateDots: FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Загрузить торговые точки'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <ShopDotsUploadDotsWidget />;
};

export default ShopDotsUpdateDots;
